var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-rox-panel" },
    [
      _c("div", { attrs: { id: "rxcApp" } }),
      _vm._v(" "),
      _vm.roxPanelOverlay
        ? _c("rb-rox-panel-skeleton", {
            ref: "skeleton",
            attrs: { "product-type": _vm.roxPanelOverlayType },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("rb-rox-understand-your-prescription", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "understandYourPrescriptionContent",
      }),
      _vm._v(" "),
      _c("rb-rox-measure-pupillary-distance", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "measurePupillaryDistance",
      }),
      _vm._v(" "),
      _c("rb-rox-protection-plan", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "protectionPanelAndModal",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }